import React from 'react';
import ReactDOM from 'react-dom';
import './Static/CSS/index.css';
import App from './App';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

ReactDOM.render(
  <Router>
    <Route component={App} />
  </Router>,
  document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js